/* eslint-disable react/no-unescaped-entities */
// src/components/Footer/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthOptional } from '../../contexts/AuthContext';
import { METIER_SLUGS, METIERS_DATA } from '../../pages/MetierLanding/metiersData';
import './Footer.css';

function capitalizeFirst(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}

const Footer: React.FC = () => {
  const { t } = useTranslation('footer');
  const { t: tMetier } = useTranslation('metiers');
  const isAuthenticated = useAuthOptional()?.isAuthenticated ?? false;
  const currentYear = new Date().getFullYear();

  const serviceLabel = (slug: string) => {
    const localized = tMetier(`${slug}.singular`, { defaultValue: '' });
    if (localized) return capitalizeFirst(localized);
    const m = METIERS_DATA[slug];
    if (!m) return slug;
    return capitalizeFirst(m.singular);
  };

  return (
    <footer className='footer' role='contentinfo'>
      <div className='footer-content'>
        <div className='footer-columns'>
          <div className='footer-column'>
            <h4 className='footer-column-title'>{t('columnRintintin')}</h4>
            <nav className='footer-column-links'>
              <Link to='/about'>{t('about')}</Link>
              <Link to='/comment-ca-marche'>{t('howItWorks')}</Link>
              <Link to='/contact'>{t('contact')}</Link>
              <Link to='/blog'>{t('blog')}</Link>
            </nav>
          </div>

          <div className='footer-column'>
            <h4 className='footer-column-title'>{t('columnServices')}</h4>
            <nav className='footer-column-links'>
              {METIER_SLUGS.map(slug => (
                <Link key={slug} to={`/services/${slug}`}>
                  {serviceLabel(slug)}
                </Link>
              ))}
            </nav>
          </div>

          <div className='footer-column'>
            <h4 className='footer-column-title'>{t('columnPro')}</h4>
            <nav className='footer-column-links'>
              <a href='https://www.rintintin-pro.com/' target='_blank' rel='noopener noreferrer'>
                {t('proPortalLink')}
              </a>
            </nav>
          </div>

          <div className='footer-column'>
            <h4 className='footer-column-title'>{t('columnAccount')}</h4>
            <nav className='footer-column-links'>
              {isAuthenticated ? (
                <>
                  <Link to='/profile'>{t('myProfile')}</Link>
                  <Link to='/reservations'>{t('myBookings')}</Link>
                </>
              ) : (
                <>
                  <Link to='/login'>{t('signIn')}</Link>
                  <Link to='/signup'>{t('signUp')}</Link>
                </>
              )}
              <Link to='/legal'>{t('legal')}</Link>
              <Link to='/terms-of-use'>{t('terms')}</Link>
              <Link to='/privacy-policy'>{t('privacy')}</Link>
            </nav>
          </div>
        </div>

        <div className='footer-bottom'>
          <p>{t('copyright', { year: currentYear })}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
